import React from 'react';
import {
  Button,
  useThemeStrings,
  GDSCustomizableComponent,
} from '@leagueplatform/genesis-core';
import { useMasonryEngineActionEmitter } from '@leagueplatform/masonry-engine';
import { MasonryDismissAction } from 'common/masonry-types';

type DismissButtonProps = {
  onDismiss: MasonryDismissAction;
  toolbarButton?: boolean;
} & GDSCustomizableComponent;

export const DismissButton = ({
  onDismiss,
  toolbarButton,
  css,
}: DismissButtonProps) => {
  const invokeAction = useMasonryEngineActionEmitter();
  const strings = useThemeStrings();

  return (
    <Button
      className="dismiss-button"
      hideLabel
      size={toolbarButton ? 'toolbar' : 'medium'}
      icon="interfaceClose"
      priority="tertiary"
      css={css}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(!toolbarButton && { quiet: true })}
      onClick={(event: React.MouseEvent) => {
        if (onDismiss) {
          invokeAction({
            event,
            ...onDismiss,
          });
        }
      }}
    >
      {strings.dismiss}
    </Button>
  );
};
